<template>
<div>
  <!-- 2020 0212 반응형 -->
  <div class="title-bar responsive-wrapper" type="flex" justify="space-between">
    <div class="top-left">
      <div class="setting-title-wrapper title">관리 대상 목록</div>
      <div class="setting-title-wrapper">
        <el-button size="mini" type="secondary" @click="clickRegistMagicianButton">등록 마법사</el-button>
        <el-button size="mini" type="primary" @click="clickAddNetworkButton">수동 등록</el-button>
        <w-group-save-button :disabled="checkedRows.length == 0" managetype-id="NMS"
        :rsc-event-rule-list="rscEventRuleList" :event-alarm-rule-list="eventAlarmRuleList" @group-save="groupSave"/>
        <el-button size="mini" :disabled="checkedRows.length == 0" @click="clickDeleteNetdeviceButton">장비 삭제</el-button>
        <el-button size="mini" :disabled="checkedRows.length == 0" @click="syncNetdevice">장비 동기화</el-button>
        <span class="mr-r5">관리여부</span>
          <div class="setting-addel">
            <el-button size="mini" @click="AllCheckChangeButtonClick('1')"><i class="fas fa-check-square"></i></el-button>
            <!-- 0411 스타일 추가 -->
            <el-button size="mini" style="margin-bottom:1px" @click="AllCheckChangeButtonClick('0')"><i class="far fa-square"></i></el-button>
          </div>
      </div>
    </div>
    <div style="width:48%;float:right">
      <div style="float: right">
      <div class="setting-title-wrapper_r mr-4">
        <el-checkbox style="margin-top:8px" v-model="lastThreeDaysFlag" @change="onChangeThreeFlag">최근 3일 이내 등록된 장비 <em>{{recentRegisteredNetdeviceCount}}개</em></el-checkbox>
      </div>
      <div class="setting-title-wrapper_r">
        <w-excel-import-popup-button ref="excelImportPopupButton" class="mr-l4 drag" title="네트워크 관리대상 엑셀 입력" @import-excel="importExcel"/>
        <el-button class="drag" size="mini" @click="onClickExportExcel">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀출력</span>
        </el-button>
        <el-button class="lifting" type="primary" @click="clickSaveButton" :disabled="!cellEditing.isModified">저장</el-button>
        <el-button class="lifting" @click="clickCancelButton" :disabled="!cellEditing.isModified">취소</el-button>
        <w-header-pagination class="lifting" :pagination="pagination" @current-change="handlerHeaderCurrentChange"></w-header-pagination>
        <w-header-search-button class="lifting" size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div></div>
    </div>
  </div>
    <el-row>
    <el-table-wrapper :editable="true" :data="netdeviceTableData" :columns="netdeviceTableColumns" :column-default="columnDefault" ref="netdeviceTable" @selection-change="changeCheckedRow" :pagination="true" :show-search-tool="showSearchTool"
      :show-custom-header="true" @condition-change="changeTableCondition" @pagination-change="handlerPaginationChange" @total-change="handlerPaginationChange" @cell-dblclick="handlerCellDbClick" remote :total="total">

      <!-- editable slot -->
      <template slot-scope="scope" slot="switch-slot">
        <w-switch-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" active-value="1" inactive-value="0" @cell-edit-end="editTwoStatusCell" />
      </template>
      <template slot-scope="scope" slot="input-slot">
        <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="ipaddress-slot">
        <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :validation="ipValidator" @cell-edit-end="endIpaddressEdit" />
      </template>
      <template slot-scope="scope" slot="checkbox-slot">
        <w-checkbox-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" true-label="1" false-label="0" @cell-edit-end="editTwoStatusCell" />
      </template>
      <template slot-scope="scope" slot="objtype-slot">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="objtypeList" keyField="objtypeId" labelField="objtypeName" valueField="objtypeId" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="model-slot">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="filteredObjProductList"
          keyField="objProductId" labelField="objProductId" valueField="objProductId" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="rsc-rule-slot">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="rscEventRuleList"
          keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="event-rule-slot">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="eventAlarmRuleList"
          keyField="ruleTmplId" labelField="ruleTmplName" valueField="ruleTmplId" @cell-edit-end="endEdit"/>
      </template>
      <template slot-scope="scope" slot="obj-importance-slot">
        <w-number-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :min="0" :max="5" @cell-edit-end="endEdit" />
      </template>
      <!-- etc slot -->
      <template slot-scope="scope" slot="netinterface-count-slot">
        <span class="link c-pointer" @click="clickNetinterfaceCount(scope.row)">
          {{scope.row.netinterfaceCount}}
        </span>
      </template>
      <template #readonly-checkbox-slot="scope">
        <el-checkbox :value="scope.row.staticFlag" true-label="1" false-label="0" class="checkbox-agent-static-flag" style="cursor: default !important;" />
      </template>
    </el-table-wrapper>
  </el-row>
  <w-add-network-popup ref="addNetworkPopup" @re-load="loadData"></w-add-network-popup>
  <w-vendor-sliding-popup ref="vendorSlidingPopup" @apply-vendor="onApplyVendor" />
  <w-skcc-customer-sliding-popup ref="skccCustomerSlidingPopup" @apply-skcc-customer="onApplySkccCustomer" />
</div>
</template>

<script>
import { cloneDeep, isNil, isEmpty, forEach, filter, isEqual } from 'lodash';

import DeviceRegistrationCommonAPI from '@/api/settings/common/device-registration-common';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';
import commonAPI from '@/api/config/common';
import RuleAPI from '@/api/settings/common/rule';
import ObjtypeAPI from '@/api/model/objtype';
import FileApi from '@/api/common/file';

import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, validateIpv4, validateIpv6, getValueAfterCheckEmpty } from '@/utils/string';
import { checkNetdeviceObjDefine } from '@/utils/wireless-device';
import msgUtil from '@/utils/message';
import { customer } from '@/constants/customer-define';
import { columnDefault, defaultPagination } from '@/constants/table';
import CellEditingMixin from '@/mixins/table/cell-editing';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import WNumberEditor from '@/components/table/cell-editor/NumberEditor';
import WSelectEditor from '@/components/table/cell-editor/SelectEditor';
import WCheckboxEditor from '@/components/table/cell-editor/CheckboxEditor';
import WSwitchEditor from '@/components/table/cell-editor/SwitchEditor';
import WHeaderPagination from '@/components/table/HeaderPagination';
import WVendorSlidingPopup from '@/views/settings/components/popup/VendorSlidingPopup';
import WAddNetworkPopup from './popup/AddNetworkPopup';
import WGroupSaveButton from '../components/GroupSaveButton';
import WSkccCustomerSlidingPopup from './popup/SkccCustomerSlidingPopup';
import WExcelImportPopupButton from '../components/ExcelImportPopupButton';

const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WNetdevice',
  mixins: [CellEditingMixin],
  components: {
    WAddNetworkPopup,
    WHeaderPagination,
    WInputEditor,
    WNumberEditor,
    WSelectEditor,
    WCheckboxEditor,
    WSwitchEditor,
    WVendorSlidingPopup,
    WGroupSaveButton,
    WSkccCustomerSlidingPopup,
    WExcelImportPopupButton,
  },
  props: {
    activeTab: String,
  },
  data() {
    return {
      customer,
      columnDefault,
      type: 'rsctype',
      showSearchTool: false,
      selectedRow: null,
      total: 0,
      rscEventRuleList: [],
      eventAlarmRuleList: [],
      objProductList: [],
      filteredObjProductList: [],
      objtypeList: [],
      netdeviceTableData: [],
      changeNetdeviceTableDataFlag: false,
      checkedRows: [],
      lastThreeDaysFlag: false,
      pagination,
      recentRegisteredNetdeviceCount: null,
      loadFromThreeDataFlag: false,
      netdeviceTableColumns: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'objManagementApplyFlag',
          label: '관리여부',
          editable: true,
          scopedSlot: 'switch-slot',
          width: 85,
          sortable: true,
          filters: [
            {
              text: '관리',
              value: '1',
            },
            {
              text: '비관리',
              value: '0',
            },
          ],
        },
        {
          prop: 'objName',
          label: '장비명',
          editable: true,
          scopedSlot: 'input-slot',
          minwidth: 150,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddressLabel',
          label: 'IP',
          editable: true,
          scopedSlot: 'ipaddress-slot',
          width: 120,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'agentManagerName',
          label: '수집서버명',
          searchable: true,
          sortable: true,
          formatter: this.formatterForCheckEmptyValue,
        },
        {
          prop: 'staticFlag',
          label: '고정여부',
          scopedSlot: 'readonly-checkbox-slot',
          width: 55,
          align: 'center',
        },
        {
          prop: 'objtypeId',
          label: '장비종류',
          editable: true,
          scopedSlot: 'objtype-slot',
          width: 120,
          searchable: true,
          remoteProp: 'objtypeName',
          // formatter: this.formatterForCheckEmptyValue,
        },
        {
          prop: 'objCompanyId',
          label: '제조사',
          editable: true,
          // scopedSlot: 'company-slot',
          width: 120,
          searchable: true,
          remoteProp: 'objCompanyName',
          formatter: this.formatterForObjCompanyId,
        },
        {
          prop: 'objProductId',
          label: '모델',
          editable: true,
          scopedSlot: 'model-slot',
          width: 120,
          searchable: true,
          // formatter: this.formatterForCheckEmptyValue,
        },
        {
          prop: 'netinterfaceCount',
          label: '인터페이스',
          width: 75,
          scopedSlot: 'netinterface-count-slot',
        },
        {
          prop: 'alivecheckFlagSnmp',
          label: 'SNMP',
          editable: true,
          scopedSlot: 'checkbox-slot',
          width: 60,
          align: 'center',
        },
        {
          prop: 'alivecheckFlagIcmp',
          label: 'ICMP',
          editable: true,
          scopedSlot: 'checkbox-slot',
          width: 60,
          align: 'center',
        },
        {
          prop: 'alivecheckFlagTcpport',
          label: 'TCP',
          editable: true,
          scopedSlot: 'checkbox-slot',
          width: 60,
          align: 'center',
        },
        {
          prop: 'eventExceptFlag',
          label: '이벤트 제외',
          editable: true,
          scopedSlot: 'checkbox-slot',
          width: 80,
          align: 'center',
        },
        {
          prop: 'objImportance',
          label: '중요도',
          editable: true,
          scopedSlot: 'obj-importance-slot',
          width: 60,
          formatter: this.formatterForCheckEmptyValue,
        },
        {
          prop: 'rscEventRuleId',
          label: '수집/판단정책',
          editable: true,
          scopedSlot: 'rsc-rule-slot',
          width: 150,
          searchable: true,
          remoteProp: 'rscrt.rule_tmpl_name',
        },
        {
          prop: 'eventAlarmRuleId',
          label: '이벤트/판단정책',
          editable: true,
          scopedSlot: 'event-rule-slot',
          width: 150,
          searchable: true,
          remoteProp: 'eventrt.rule_tmpl_name',
        },
        {
          prop: 'registDatetime',
          label: '장비 등록일',
          width: 130,
          formatter: this.getDateFormatter,
          sortable: true,
          searchable: true,
          searchType: 'date',
        },
      ],
    };
  },
  computed: {
    forceNetworkModelingResultLoad() {
      return this.$store.state.setting.forceNetworkModelingResultLoad;
    },
    customerId() {
      return this.$store.state.common.customerId;
    },
  },
  watch: {
    forceNetworkModelingResultLoad: {
      immediate: true,
      handler(to) {
        if (to) {
          if (!this.isLoading) {
            this.loadData();
          }
          this.$store.dispatch('setforceNetworkModelingResultLoad', false);
        }
      },
    },
    customerId: {
      handler(to) {
        if (!isNil(to)) {
          if (to === this.customer.SKCC || to === this.customer.SKT) {
            this.netdeviceTableColumns.splice(12, 0, {
              prop: 'skccCustomerId',
              label: '고객사',
              editable: true,
              searchable: true,
              width: 80,
              remoteProp: 'sc.customer_name',
              formatter: this.formatterForSkccCustomerId,
            });
          }
        }
      },
      immediate: true,
    },
  },
  created() {
    RuleAPI.getRscEventRules().then((response) => {
      this.rscEventRuleList = response.data.data;
    });
    RuleAPI.getEventAlarmRulesByManagetypeId('NMS').then((response) => {
      this.eventAlarmRuleList = response.data.data;
    });
    commonAPI.getObjProductList({}).then((res) => {
      this.objProductList = res.data.data;
    });
    ObjtypeAPI.getObjtypeList('NMS').then((response) => {
      this.objtypeList = cloneDeep(response.data.data);
    });
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.netdeviceTable.getParameter();
      const params = {
        lastThreeDaysFlag: this.lastThreeDaysFlag,
        ...tableParams,
      };
      // '최근 3일 이내 등록된 장비' 클릭 시 start 값이 기존 값으로 남아있는 문제 인지, 초기화 추가
      if (this.loadFromThreeDataFlag) {
        params.start = 0;
      }
      DeviceRegistrationNmsAPI.getRecentRegisteredNetdeviceCount().then((response) => {
        this.recentRegisteredNetdeviceCount = response.data.data;
      });
      this.isLoading = true;
      this.loadFromThreeDataFlag = false;
      DeviceRegistrationNmsAPI.getNetdeviceList(params)
        .then((response) => {
          this.total = response.data.total;
          const data = response.data.data;
          this.netdeviceTableData = this.getEditableTableData(data, this.netdeviceTableColumns);
          this.resetCellEditing();
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    /**
     * [테이블 페이징] 페이지 변경 핸들러
     * @author Ju
     * @param  {Object} pagination 페이지 정보 객체
     */
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    /**
     * [헤더 페이징] 현재 페이지 변경 핸들러
     * @author Ju
     * @param  {Number} currentPage 현재 페이지 번호
     */
    handlerHeaderCurrentChange(_currentPage) {
      this.$refs.netdeviceTable.setCurrentPage(_currentPage);
    },
    clickSaveButton() {
      const updatedData = this.getUpdatedDatas(this.netdeviceTableData, true, ['objId', 'objCompanyId']);
      let ipDuplicatedFlag = false;
      const ipList = [];
      updatedData.forEach((obj) => {
        const ipaddress = obj.ipaddressLabel;
        if (ipList.includes(ipaddress)) {
          ipDuplicatedFlag = true;
        }
        ipList.push(ipaddress);
        if (validateIpv4(ipaddress)) {
          obj.ipaddressApplytype = 'IPv4';
          obj.ipaddressIpv4 = ipaddress;
        } else {
          obj.ipaddressApplytype = 'IPv6';
          obj.ipaddressIpv6 = ipaddress;
        }
        checkNetdeviceObjDefine(obj);
      });

      if (ipDuplicatedFlag) {
        this.$message(msgUtil.getCustomResultMsgData('중복된 IP가 존재합니다.', false));
        return;
      }

      const target = '관리 대상';
      const action = msgUtil.action.SAVE;
      DeviceRegistrationNmsAPI.updateNetdeviceList(updatedData)
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, result.success));
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    clickCancelButton() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    clickDeleteNetdeviceButton() {
      const target = '관리 대상';
      const action = msgUtil.action.DELETE;

      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        DeviceRegistrationNmsAPI.deleteNetdeviceList(this.checkedRows)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    clickNetinterfaceCount(row) {
      this.$emit('select-netdevice', row);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    formatterForCheckEmptyValue(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    clickAddNetworkButton() {
      this.$refs.addNetworkPopup.$refs.slidingPopup.visible = true;
    },
    clickRegistMagicianButton() {
      this.$emit('click-regist-magician-button');
    },
    changeTableCondition() {
      this.loadData();
    },
    AllCheckChangeButtonClick(objManagementApplyFlag) {
      const result = this.editDirectBulk(this.netdeviceTableData, 'objManagementApplyFlag', objManagementApplyFlag);
      this.netdeviceTableData = result.tableData;
      this.completeEditBulk(...result);
    },
    syncNetdevice() {
      const target = '네트워크 장비';
      const action = '동기화';

      const objIds = [];
      forEach(this.checkedRows, (obj) => {
        objIds.push(obj.objId);
      });
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        DeviceRegistrationNmsAPI.syncNetdevice(objIds)
          .then((response) => {
            const result = response.data;
            if (result.success === true) {
              this.$message(msgUtil.getResultMsgData(action, target, true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    formatterForObjCompanyId(row) {
      const objCompanyId = row.objCompanyId;
      if (isNil(objCompanyId)) {
        return EMPTY_TEXT;
      }
      return row.objCompanyName;
    },
    formatterForSkccCustomerId(row) {
      const skccCustomerId = row.skccCustomerId;
      if (isNil(skccCustomerId)) {
        return EMPTY_TEXT;
      }
      return row.skccCustomerName;
    },
    /**
     * 셀 더블 클릭 이벤트 핸들러
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @return {[type]}        [description]
     */
    handlerCellDbClick(row, column) {
      if (column.property === 'objCompanyId') {
        this.editingRow = row;
        this.openVendorPopup();
      } else if (column.property === 'skccCustomerId') {
        this.editingRow = row;
        this.$refs.skccCustomerSlidingPopup.open();
      } else {
        this.startEdit(row, column); // 더블 클릭 시 편집 이외의 동작이 필요할 경우는 별도 이벤트 핸들러를 작성하며 그렇지 않으면 바로 startEdit를 이벤트 핸들러로 사용하면 됨.
      }
    },
    /**
     * 셀 편집 전처리
     * @author Ju
     * @param  {[type]} data     [description]
     * @param  {[type]} property [description]
     */
    handlerStartEdit(data, property) {
      if (property === 'objProductId') {
        // objProductId일 경우 objCompanyId에 해당하는 모델 목록만 설정.
        if (!isNil(data.objCompanyId) && data.objCompanyId !== '') {
          this.filteredObjProductList = filter(this.objProductList, (item) => item.objCompanyId === data.objCompanyId);
        } else {
          this.filteredObjProductList = [];
        }
      }
    },
    /**
     * 셀 편집 후처리
     * @author Ju
     * @param  {[type]} data     [description]
     * @param  {[type]} property [description]
     * @param  {[type]} dirty    [description]
     */
    handlerEndEdit(data, property, dirty) {
      if (dirty) {
        if (property === 'objCompanyId') {
          // objCompanyId 수정 시 objProductId 값 null 설정.
          this.editDirect(data, 'objProductId', null);
        }
      }
      this.checkExistModifiedData(this.netdeviceTableData);
    },
    /**
     * 벤더 팝업에서 선택한 벤더를 콤보박스에 설정한다.
     * @author Ju
     * @param  {[type]} data [description]
     */
    onApplyVendor(data) {
      const editingRow = this.editingRow;
      editingRow.objCompanyName = data.objCompanyName;
      this.editDirect(editingRow, 'objCompanyId', data.objCompanyId);
      this.editingRow = null;
    },
    onApplySkccCustomer(data) {
      const editingRow = this.editingRow;
      editingRow.skccCustomerName = data.customerName;
      this.editDirect(editingRow, 'skccCustomerId', data.customerId);
      this.editingRow = null;
    },
    /**
     * 벤더 팝업을 연다
     * @author Ju
     */
    openVendorPopup() {
      this.$refs.vendorSlidingPopup.open();
    },
    ipValidator(value) {
      return validateIpv4(value) || validateIpv6(value);
    },
    onChangeThreeFlag() {
      this.loadFromThreeDataFlag = true;
      this.$nextTick(() => {
        this.$refs.netdeviceTable.setCurrentPage(1);
      });
    },
    onClickExportExcel() {
      const tableParams = this.$refs.netdeviceTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        lastThreeDaysFlag: this.lastThreeDaysFlag,
        ...tableParams,
      };

      DeviceRegistrationNmsAPI.excelExportNetdeviceList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    groupSave(data) {
      if (!isEmpty(data)) {
        const checkedRows = cloneDeep(this.checkedRows);
        const updatedData = checkedRows.map((item) => {
          const result = {
            objId: item.objId,
            objProductId: item.objProductId,
            ...data,
          };
          if (isNil(data.objImportance)) {
            result.objImportance = item.objImportance;
          }
          if (isNil(data.skccCustomerId) && (this.customerId === this.customer.SKCC || this.customerId === this.customer.SKT)) {
            result.skccCustomerId = item.skccCustomerId;
          }
          if (isNil(data.rscEventRuleId) && !isNil(data.eventAlarmRuleId)) {
            result.rscEventRuleId = item.rscEventRuleId;
          } else if (!isNil(data.rscEventRuleId) && isNil(data.eventAlarmRuleId)) {
            result.eventAlarmRuleId = item.eventAlarmRuleId;
          }
          return result;
        });
        const target = '관리 대상';
        const action = msgUtil.action.SAVE;
        DeviceRegistrationNmsAPI.updateNetdeviceList(updatedData)
          .then((response) => {
            const result = response.data;
            if (result.success) {
              this.loadData();
            }
            this.$message(msgUtil.getResultMsgData(action, target, result.success));
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      }
    },
    importExcel(data) {
      // 엑셀 입력
      DeviceRegistrationNmsAPI.excelImportNetdeviceList(data).then((res) => {
        if (res.data.success) {
          this.loadData();
          this.$refs.excelImportPopupButton.closePopup();
          const message = res.data.data.message;
          const extraMessage = res.data.data.extraMessage;
          this.$message({
            dangerouslyUseHTMLString: true,
            message: !isNil(extraMessage) ? `${message}<br /><br />${extraMessage}` : message,
            duration: 5000,
          });
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '엑셀 입력', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.APPLY, '엑셀 입력', false));
      });
    },
    endIpaddressEdit(newValue) {
      console.debug('-- end direct', newValue, this.cellEditing.data, this.cellEditing.property, this.cellEditing);
      const data = this.cellEditing.data;
      const property = this.cellEditing.property;

      if (data && property) {
        // TODO: Ediotr의 keyup 이벤트로 endEdit가 호출되는 경우, keyup 이벤트에 endEdit 한번 호출,
        // blur 이벤트에서 한번 호출 총 2번 호출이 가서 2번째에서 editing 객체가 초기화되어 에러남.
        // 일단  data와 property가 있을 경우만 하단의 로직 수행하도록 처리함.

        // ipValidation check
        let dirty = isEqual(this.cellEditing.originalValue, newValue);
        if (!dirty) {
          const params = {
            objManagetypeId: 'NMS',
            ipaddressApplytype: data.ipaddressApplytype,
          };
          if (validateIpv4(newValue)) {
            params.ipaddressIpv4 = newValue;
          } else if (validateIpv6(newValue)) {
            params.ipaddressIpv6 = newValue;
          }
          if (validateIpv4(newValue) || validateIpv6(newValue)) {
            DeviceRegistrationCommonAPI.checkIpaddressValidation(params).then((response) => {
              if (response.data.data) {
                dirty = this.setModified(data, property, this.cellEditing.originalValue, newValue);
              } else {
                dirty = this.setModified(data, property, this.cellEditing.originalValue, data.ipaddressLabel);
              }
            }).catch(() => {
            }).finally(() => {
              this.completeEdit(data, property, dirty);
            });
          }
        } else {
          dirty = this.setModified(data, property, this.cellEditing.originalValue, newValue);
          this.completeEdit(data, property, dirty);
        }
      }
    },
  },
};
</script>

<style>
.checkbox-agent-static-flag .el-checkbox__input {
  cursor: default !important;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/Netdevice.vue